import { COLOR_NEUTRALS_3, COLOR_WHITE } from '../colors.constant';

export const colorsCountdownLight = {
  colorCountdownText: COLOR_NEUTRALS_3,
};

export const colorsCountdownDark = {
  colorCountdownText: COLOR_WHITE,
};
